
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {Component, NgZone, ViewChild,ElementRef, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DebidaDiligencia } from 'app/main/models/debida-diligencia.model';
import { DebidaDiligenciaService } from 'app/main/services/debida-diligencia.service';
import { first,take } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import { environment } from 'environments/environment';
import { UtilsService } from 'app/main/services/utils.service';
import { AppConfig } from 'app/app-config';



@Component({
  selector: 'app-dialog-print-box',
  templateUrl: './dialog-print-box.component.html',
  styleUrls: ['./dialog-print-box.component.scss']
})
export class DialogBoxPrintComponentDebidaDiligencia {

  action: string;
  debidasDiligencias: DebidaDiligencia[] = [];
  displayedColumns: string[] = ['nombre', 'estructuraJerarquica','marcoDeReferencia','tablasDeEvaluacion',
                            'responsable','estado','fechaFin'];

  organizacion : string;
  fecha: Date = new Date();
  disabled : boolean = false;

  constructor(
    private _ngZone: NgZone,
    private service: DebidaDiligenciaService,
    public dialogRef: MatDialogRef<DialogBoxPrintComponentDebidaDiligencia>,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    private utils: UtilsService,
    private appConfig:AppConfig,
    //private _fuseProgressBarService: FuseProgressBarService,

    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.debidasDiligencias = data.obj;
    this.action = data.action;
    //this.organizacion = environment.cliente;
    this.organizacion = appConfig.cliente;
    //this.setLocal(data.obj);
  }


  print(): void{

  }

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {


  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  public printPdf()
  {
    this.disabled=true;
    this.utils.printPdf();
    this.disabled=false;

  }

}
